import React from 'react';
import Contact from '../components/Contact';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { companyInfo } from '../data';

const ContactPage = () => {
  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-20 bg-slate-50 overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-10">
          <div className="absolute top-0 right-0 w-1/3 h-full bg-orange-600/20 skew-x-12 transform translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-1/3 h-full bg-slate-900/10 -skew-x-12 transform -translate-x-1/2"></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 mb-6">
              Lad os tage en <span className="text-orange-600">snak</span> om dit projekt
            </h1>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              Jeg er altid klar til at hjælpe dig med professionel rådgivning og et uforpligtende tilbud. 
              Uanset om det er en ny indkørsel, terrasse eller haveanlæg, står jeg klar.
            </p>
          </div>
        </div>
      </section>

      {/* Info Cards */}
      <section className="py-12 -mt-12 relative z-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-8 rounded-2xl shadow-xl shadow-slate-200/50 flex flex-col items-center text-center">
              <div className="w-14 h-14 bg-orange-100 rounded-2xl flex items-center justify-center mb-4">
                <Phone className="w-7 h-7 text-orange-600" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Ring til mig</h3>
              <a href={`tel:+45${companyInfo.phone.replace(/\s/g, '')}`} className="text-slate-600 hover:text-orange-600 transition-colors font-medium">
                +45 {companyInfo.phone}
              </a>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-xl shadow-slate-200/50 flex flex-col items-center text-center">
              <div className="w-14 h-14 bg-orange-100 rounded-2xl flex items-center justify-center mb-4">
                <Mail className="w-7 h-7 text-orange-600" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Send en mail</h3>
              <a href={`mailto:${companyInfo.email}`} className="text-slate-600 hover:text-orange-600 transition-colors font-medium break-all">
                {companyInfo.email}
              </a>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-xl shadow-slate-200/50 flex flex-col items-center text-center">
              <div className="w-14 h-14 bg-orange-100 rounded-2xl flex items-center justify-center mb-4">
                <MapPin className="w-7 h-7 text-orange-600" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Besøg efter aftale</h3>
              <p className="text-slate-600 font-medium">
                {companyInfo.address}<br />
                {companyInfo.zipCity}
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-xl shadow-slate-200/50 flex flex-col items-center text-center">
              <div className="w-14 h-14 bg-orange-100 rounded-2xl flex items-center justify-center mb-4">
                <Clock className="w-7 h-7 text-orange-600" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Åbningstider</h3>
              <p className="text-slate-600 font-medium">
                Man - Fre: 07:00 - 17:00<br />
                Lør - Søn: Efter aftale
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Main Contact Section */}
      <div className="bg-white">
        <Contact />
      </div>

      {/* FAQ or Additional Info could go here */}
      <section className="py-24 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-slate-900 mb-6">Ofte stillede spørgsmål</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left mt-12">
            <div>
              <h4 className="font-bold text-slate-900 mb-2">Hvor hurtigt kan du komme ud?</h4>
              <p className="text-slate-600">Jeg bestræber mig på at besigtige opgaver inden for 48 timer og give et uforpligtende tilbud kort efter.</p>
            </div>
            <div>
              <h4 className="font-bold text-slate-900 mb-2">Koster et tilbud noget?</h4>
              <p className="text-slate-600">Nej, jeg tilbyder altid gratis rådgivning og uforpligtende tilbud på alle brolægningsopgaver.</p>
            </div>
            <div>
              <h4 className="font-bold text-slate-900 mb-2">Hvilket område dækker du?</h4>
              <p className="text-slate-600">Jeg opererer primært i og omkring Egtved, Kolding, Vejle og omegn, men tager gerne imod opgaver i hele Trekantområdet.</p>
            </div>
            <div>
              <h4 className="font-bold text-slate-900 mb-2">Giver du garanti på arbejdet?</h4>
              <p className="text-slate-600">Ja, alt mit arbejde udføres efter højeste standarder, og jeg yder naturligvis garanti på alle projekter.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
